<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="header">问卷调查</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="createVote">新建问卷</Button>
      </div>
    </div>
    <div class="content">
      <Card v-if="isJiedao">
        <div class="select-wrapper">
          <div class="name">行政区域</div>
          <Select v-model="communityId" class="input" @on-change="changeCommunity">
            <Option v-for="item in childShequ" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>
      </Card>
      <Card class="card" style="margin-top: 20px">
        <Table border :columns="columns1" :data="votedata" :loading="isTableLoading"></Table>
        <div class="page">
          <Page :total="total" :current="pageNum" @on-change="handleChangePage" show-total />
        </div>
      </Card>
    </div>
    <!-- 删除Modal -->
    <Modal v-model="showDel" title="删除" @on-ok="delVote">
      <p style="color: #d22c2d;text-align: center">确定删除本次投票吗？删除后数据将无法恢复</p>
    </Modal>
    <!-- 分享Modal -->
    <Modal v-model="showShare" title="分享">
      <div class="text">
        1.分享微信好友或微信群：请扫码，扫码后点击
        <i class="iconfont icon-daochu"></i>分享
      </div>
      <div class="code-img">
        <img v-for="(item, index) in codeUrl" :key="index" :src="item" alt />
      </div>
      <div class="text">
        2.分享朋友圈请
        <span @click="downPic">下载素材</span>，发布朋友圈
      </div>
    </Modal>
  </div>
</template>

<script>
var that;
export default {
  data() {
    return {
      columns1: [
        {
          title: "投票标题",
          key: "title"
        },
        {
          title: "参与人数",
          key: "number",
          width: 161
        },
        {
          title: "状态",
          key: "status",
          width: 168
        },
        {
          title: "截止日期",
          key: "date",
          width: 244
        },
        {
          title: "操作",
          width: 317,
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94"
                  },
                  on: {
                    click: () => {
                      that.toDetail(params.index);
                    }
                  }
                },
                "[详情]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: () => {
                      that.toNewVote(params.index);
                    }
                  }
                },
                "[编辑]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: () => {
                      console.log(params);
                      that.showShareModal(params.index);
                    }
                  }
                },
                "[分享]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: () => {
                      that.showDelVote(params.index);
                    }
                  }
                },
                "[删除]"
              )
            ]);
          }
        }
      ],
      votedata: [],
      pageNum: 1,
      pageSize: 10,
      total: 20,
      isTableLoading: false,
      showDel: false,
      delIndex: "",
      showShare: false,
      codeUrl: "",
      voteId: "",
      childShequ: [],
      communityIdList: [parseInt(this.$store.state.streetorcommunityid)],
      communityId: parseInt(this.$store.state.streetorcommunityid),
    };
  },
  computed :{
    isJiedao () {
      console.log(this.$store.state.isJiedao)
      return parseInt(this.$store.state.isJiedao);
    }
  },
  created() {
    that = this;
    // for (var i = 0; i < 10; i++) {
    //   this.votedata.push(this.votedata[0]);
    // }
    // this.getapp()
  },
  mounted() {
    
    if (this.$store.state.isJiedao) {
      this.getChildShequ();
    }else{
      this.getVoteList(this.communityIdList);
    }
  },
  methods: {
    getChildShequ() {
      var url = this.urlobj.getChildShequ;
      this.$get(url).then(res => {
        var ids = res.rows.map(item => {
          return item.communityId
        })
        ids = ids.join(',')
        var item = {
          name: '全部',
          id: ids
        }
        var list = res.rows.map(item => {
          return {
            name: item.communityName,
            id: item.communityId
          };
        });
        list.unshift(item)
        console.log(list)
        this.communityId = ids
        this.communityIdList = ids.split(',')
        this.getVoteList();
        this.childShequ = list
      });
    },
    changeCommunity(val) {
      console.log(val)
      var index = String(val).indexOf(',')
      var idlist = index == -1 ? [val] : val.split(',')
      console.log(idlist)
      this.pageNum = 1
      this.getVoteList(idlist);
    },
    getapp() {
      console.log(123);
    },
    handleChangePage(val) {
      console.log(this.communityId);
      var val1 = this.communityId
      var index = String(val1).indexOf(',')
      var idlist = index == -1 ? [val1] : val1.split(',')
      this.pageNum = val;
      this.getVoteList(idlist);
    },
    getVoteList(communityIdList) {
      var url = this.urlobj.getVoteList;
      this.isTableLoading = true;
      var data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        communityIdList
      };
      this.$post(url, data).then(res => {
        var list = res.rows.map(item => {
          return {
            title: item.title,
            number: item.userCount,
            status: item.status == 1 ? "进行中" : "已结束",
            date: item.endTime.substr(0, item.endTime.length - 2),
            id: item.id
          };
        });
        this.total = res.total;
        this.votedata = list;
        this.isTableLoading = false;
      });
    },
    showDelVote(index) {
      this.showDel = true;
      this.delIndex = index;
    },
    delVote() {
      var id = this.votedata[this.delIndex].id;
      var url = this.urlobj.deleteVote(id);
      this.isTableLoading = true;
      this.$delete(url).then(res => {
        if (res.isSucceed) {
          this.isTableLoading = false;
          this.$Message.success("删除成功");
          this.getVoteList();
        }
      });
    },
    createVote() {
      this.$router.push({ name: "newVote" });
    },
    showShareModal(index) {
      console.log(this.votedata[index])
      var data = {
        communityId: this.$store.state.streetorcommunityid,
        voteId: this.votedata[index].id,
        appType:'ipy'
      };
      this.voteId = this.votedata[index].id;
      this.$get(this.urlobj.voteCode, data).then(res => {
        if (res) {
          this.codeUrl = res.newPrimaryKeys.qrcodeUrl;
          this.showShare = true;
        }
      });
    },
    downPic() {
      var url = this.urlobj.inviteCode;
      var data = {
        communityId: this.$store.state.streetorcommunityid,
        voteId: this.voteId,
        appType: "ipy"
      };
      url +=
        "?voteId=" +
        this.voteId +
        "&appType=ipy&communityId=" +
        this.$store.state.streetorcommunityid +
        "&token=" +
        this.$store.state.access_token;
      window.open(url);
      return;
      this.$get(url, data).then(res => {});
    },
    toDetail(index) {
      this.$router.push({
        name: "voteDetail",
        query: { id: this.votedata[index].id }
      });
    },
    toNewVote(index) {
      this.$router.push({
        name: "newVote",
        query: { id: this.votedata[index].id }
      });
    }
  }
};
</script>

<style lang='less' scoped>
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  position: absolute;
  right: 20px;
}
.content {
  //   @content();
  // max-width: 96%;
  margin: 20px;
  margin-top: 0;
  overflow: hidden;
  overflow-y: scroll;
  // background: #fff;
  // padding: 0 15px 0 15px;
  &::-webkit-scrollbar {
    display: none;
  }
  .select-wrapper {
    font-size: 16px;
    margin-bottom: 20px;
    .name {
      margin-bottom: 10px;
    }
    .input {
      width: 30%;
    }
  }
  .card {
    height: 100%;
  }
  /deep/ .ivu-table-overflowX {
    overflow-x: hidden !important;
  }
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
}
.table-tabs {
  max-width: 100%;
  padding: 0;
  margin-top: 30px;

  /deep/ .ivu-tabs-bar {
    margin-bottom: 0;
    border-bottom: 0;
  }
  /deep/ .ivu-tabs-tab-active {
    color: white;
    background: #fe7d43;
    border-radius: 5px 5px 0 0;
  }
  /deep/ .ivu-tabs-ink-bar {
    height: 0px;
  }
  /deep/ .ivu-tabs-nav {
    padding-left: 10px;
    color: black;
  }
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
}
.page {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.code-img {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 172px;
  height: 172px;
  img {
    width: 172px;
    height: 172px;
  }
}
.text {
  font-size: 16px;
  span {
    text-decoration: underline;
    color: #fe7d43;
  }
}
/deep/ .ivu-table-tip table td{
  width: 100% !important;
}
/deep/ th .ivu-table-cell span {
  font-weight: bold !important;
}
</style>
